import React from 'react';
import { PageSection, BodyText, Title } from 'common/styles/page';

import { useSelector } from 'react-redux';
import { BulletListFormatter } from 'common/utils/AIUtils';
import { useApiPortalV1AssessmentsResultsListQuery } from 'areas/assessment-schedule/api';
import { getSelectedAssessmentPeriodId } from 'common/selectors/auth';

import { AggregateType } from 'common/constants/AggregateType';
const OrganizationalInsights = () => {
  const assessmentPeriodId = useSelector(getSelectedAssessmentPeriodId);

  const { data: ai_sentiment_data } = useApiPortalV1AssessmentsResultsListQuery(
    {
      aggregateType: AggregateType.AI_SUMMARY_ORGANIZATION,
      assessmentPeriodId: assessmentPeriodId,
    },
    {
      skip: !assessmentPeriodId,
      refetchOnMountOrArgChange: true,
    }
  );

  return (
    <PageSection>
      <Title padbottom="15px">Organization Insights</Title>
      {ai_sentiment_data && (
        <>
          <BodyText>{ai_sentiment_data?.[0]?.result?.summary}</BodyText>
          <BodyText>{BulletListFormatter(ai_sentiment_data?.[0]?.result?.bullets)}</BodyText>
        </>
      )}
    </PageSection>
  );
};
export default OrganizationalInsights;

